import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, AlertCircle, Rocket, TrendingUp } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";

const AnalisisFinancieroLanding = () => {
  return (
    <div data-testid="analisis-financiero-landing" className="min-h-screen bg-gradient-to-br from-[#0a0a14] via-[#13132a] to-[#0a0a14] text-white">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0a0a14]/90 backdrop-blur sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/" data-testid="back-home" className="flex items-center gap-1 text-slate-400 hover:text-white text-sm font-medium">
            <ArrowLeft className="h-4 w-4" /> Inicio
          </Link>
          <div className="w-px h-5 bg-white/20" />
          <p className="text-sm font-semibold text-white truncate flex-1">¿Cuánto puedes ganar?</p>
          <LanguageSwitcher />
        </div>
      </header>

      {/* PRUEBA REAL */}
      <section className="relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#c9a227]/15 blur-[130px] pointer-events-none" />
        <div className="relative max-w-6xl mx-auto px-4 py-14 md:py-20">
          <div className="inline-flex items-center gap-2 bg-[#c9a227]/15 text-[#c9a227] px-3 py-1 rounded-full text-[10px] font-mono tracking-[3px] uppercase mb-5">
            Prueba real · Facturación verificada
          </div>
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black leading-[1] mb-5 max-w-4xl">
            Esto no es una promesa.<br />
            <span className="text-[#c9a227]">Es lo que ya está pasando.</span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg max-w-2xl mb-8">
            Mira la cuenta real de Hotmart de Carlos Miami Fernandez. <strong className="text-white">Tú tienes exactamente la misma oportunidad de ganar dinero</strong>:
            solo necesitas las plataformas y sumarles un sistema y una estrategia para convertir la estadística en tu socio.
          </p>

          {/* Imagen Hotmart */}
          <div className="relative rounded-2xl overflow-hidden border-2 border-[#c9a227]/40 shadow-[0_20px_80px_rgba(201,162,39,0.25)] max-w-4xl">
            <img
              src="https://customer-assets.emergentagent.com/job_8cf629ed-1fda-424b-8b5f-9dfd2dabe33f/artifacts/1bajvrwd_WhatsApp%20Image%202026-07-04%20at%2009.33.12.jpeg"
              alt="Cuenta real de ventas en Hotmart — Club Viajemos"
              className="w-full h-auto"
              data-testid="hotmart-proof-image"
            />
          </div>

          {/* Promedio mensual Hotmart */}
          <div className="mt-6 max-w-4xl bg-gradient-to-br from-[#c9a227]/15 to-transparent border-2 border-[#c9a227]/40 rounded-2xl p-5 sm:p-6" data-testid="hotmart-monthly-block">
            <div className="inline-flex items-center bg-white rounded-lg px-3 py-2 mb-3">
              <img src="/logos/hotmart.png" alt="Hotmart" className="h-6 w-auto" data-testid="logo-hotmart" />
            </div>
            <p className="text-[#c9a227] text-[11px] font-black uppercase tracking-[2px] mb-1">Promedio mensual de mi ganancia</p>
            <p className="text-4xl sm:text-5xl font-black text-white tabular-nums" data-testid="hotmart-monthly-total">$69,489.28 USD</p>
            <p className="text-slate-400 text-xs mt-2">
              $1,389,785.53 dividido entre 20 meses (04/11/2023 – 04/07/2025) = tu ganancia promedio por mes.
            </p>
          </div>

          {/* Aviso 50% */}
          <div className="mt-6 flex items-start gap-3 bg-[#c9a227]/10 border border-[#c9a227]/40 rounded-xl p-4 sm:p-5 max-w-4xl">
            <AlertCircle className="h-5 w-5 text-[#c9a227] flex-shrink-0 mt-0.5" />
            <p className="text-sm sm:text-base text-[#f2e2ac] leading-relaxed">
              <strong className="text-white">Importante:</strong> este número representa <strong className="text-white">solo el 50% de la facturación</strong>,
              porque aquí solo se ve <strong className="text-white">mi ganancia</strong> — no la facturación total. La facturación real del negocio es aún mayor.
            </p>
          </div>

          {/* Bloque Stripe — Junio 2026 */}
          <div className="mt-10 max-w-4xl" data-testid="stripe-proof-block">
            <div className="inline-flex items-center gap-2 bg-[#635bff]/15 text-[#a5a0ff] px-3 py-1 rounded-full text-[10px] font-mono tracking-[3px] uppercase mb-4">
              Stripe · Solo Junio 2026
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">
              Y esto es solo un mes: <span className="text-[#80C753]">Junio 2026</span> en Stripe
            </h2>
            <p className="text-slate-300 text-sm sm:text-base mb-5 max-w-2xl">
              Estas son transferencias reales pagadas a la cuenta bancaria del negocio durante <strong className="text-white">un solo mes</strong> a través de Stripe.
            </p>

            <div className="mb-5 bg-gradient-to-br from-[#80C753]/15 to-transparent border-2 border-[#80C753]/40 rounded-2xl p-5 sm:p-6">
              <div className="inline-flex items-center bg-white rounded-lg px-3 py-2 mb-3">
                <img src="/logos/stripe.png" alt="Stripe" className="h-6 w-auto" data-testid="logo-stripe" />
              </div>
              <p className="text-[#80C753] text-[11px] font-black uppercase tracking-[2px] mb-1">Suma de las transferencias mostradas</p>
              <p className="text-4xl sm:text-5xl font-black text-white tabular-nums" data-testid="stripe-total">$15,527.96 USD</p>
              <p className="text-slate-400 text-xs mt-2">Total de las 17 transferencias visibles · Solo Junio 2026 · Vía Stripe</p>
            </div>

            <div className="relative rounded-2xl overflow-hidden border-2 border-[#635bff]/40 shadow-[0_20px_80px_rgba(99,91,255,0.25)]">
              <img
                src="https://customer-assets.emergentagent.com/job_8cf629ed-1fda-424b-8b5f-9dfd2dabe33f/artifacts/fqt9bda7_WhatsApp%20Image%202026-07-04%20at%2009.44.11.jpeg"
                alt="Transacciones reales en Stripe — Club Viajemos · Junio 2026"
                className="w-full h-auto"
                data-testid="stripe-proof-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ============ FINAL ÉPICO — SUMA TOTAL ============ */}
      <section data-testid="final-epico" className="relative overflow-hidden border-t border-white/10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#c9a227]/10 via-transparent to-[#80C753]/10 pointer-events-none" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#c9a227]/10 blur-[160px] pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-4 py-16 md:py-24 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-1.5 rounded-full text-[10px] font-mono tracking-[3px] uppercase mb-6">
            <Rocket className="h-3.5 w-3.5 text-[#c9a227]" /> Sumando las dos pruebas
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-slate-300 mb-3">Ganancia promedio mensual combinada</h2>

          {/* Logos Hotmart + Stripe */}
          <div className="flex items-center justify-center gap-3 mb-6" data-testid="epico-logos">
            <div className="inline-flex items-center bg-white rounded-lg px-3 py-2">
              <img src="/logos/hotmart.png" alt="Hotmart" className="h-6 w-auto" />
            </div>
            <span className="text-slate-400 font-black text-xl">+</span>
            <div className="inline-flex items-center bg-white rounded-lg px-3 py-2">
              <img src="/logos/stripe.png" alt="Stripe" className="h-6 w-auto" />
            </div>
          </div>

          {/* Cifra completa */}
          <div className="inline-block mb-6">
            <p
              className="text-5xl sm:text-7xl md:text-8xl font-black tabular-nums bg-gradient-to-r from-[#c9a227] via-[#f2e2ac] to-[#80C753] bg-clip-text text-transparent leading-none"
              data-testid="total-epico"
            >
              $85,017.24 <span className="text-3xl sm:text-4xl">USD/mes</span>
            </p>
            <p className="text-slate-400 text-sm mt-3">
              $69,489.28 (Hotmart · promedio mensual) + $15,527.96 (Stripe · Junio 2026) = tu ganancia promedio combinada por mes.
            </p>
          </div>

          <h3 className="text-3xl sm:text-5xl font-black text-white leading-tight mb-4">
            Y esto <span className="text-[#c9a227]">apenas comienza</span>.<br />
            El cielo es el límite. 🚀
          </h3>
          <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto mb-10">
            Tú tienes las mismas plataformas y la misma oportunidad. Con el sistema y la estrategia correcta,
            estos números pueden ser tu nueva realidad. <strong className="text-white">No hay techo para lo que puedes construir.</strong>
          </p>

          {/* CTA a simulador */}
          <Link
            to="/analisisfinanciero/simulador"
            data-testid="cta-ver-cuanto-gano"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#c9a227] to-[#e0b835] text-[#0a0a14] font-black px-8 py-5 rounded-xl uppercase tracking-wider text-sm sm:text-base hover:scale-[1.03] transition-transform shadow-[0_10px_50px_rgba(201,162,39,0.5)]"
          >
            <TrendingUp className="h-5 w-5" />
            Calcula cuánto puedes ganar tú
            <ArrowRight className="h-5 w-5" />
          </Link>
          <p className="text-slate-400 text-xs mt-4">Entra al simulador y usa tus propios números.</p>

          {/* Nota otras plataformas */}
          <div className="mt-12 max-w-3xl mx-auto bg-white/5 border border-white/15 rounded-2xl p-5 sm:p-6" data-testid="nota-otras-plataformas">
            <p className="text-white font-bold text-sm sm:text-base mb-4">
              Y esto no es todo: en estas cifras <span className="text-[#c9a227]">NO están incluidos</span> los valores que gano en RateHawk, Bedsonline y las demás plataformas, que son facturaciones aparte.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <div className="inline-flex items-center bg-white rounded-lg px-3 py-2">
                <img src="/logos/ratehawk.png" alt="RateHawk" className="h-5 w-auto" data-testid="logo-ratehawk" />
              </div>
              <div className="inline-flex items-center bg-white rounded-lg px-4 py-2">
                <span className="font-black text-[#1D1D1B] text-sm tracking-tight lowercase">bedsonline</span>
              </div>
              <div className="inline-flex items-center bg-white/10 border border-white/20 rounded-lg px-4 py-2">
                <span className="font-bold text-slate-300 text-sm">+ otras plataformas</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnalisisFinancieroLanding;
